import React, { useMemo, useState } from 'react';
import SelectField from '../common/SelectField.js';
import ProductCard from './ProductCard.js';

const ProductListingSection = ({
  categories,
  category,
  setCategory,
  filteredProducts,
  addReceiptItem,
  getProductAvailability,
  receiptItems
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  const displayedProducts = useMemo(() => {
    const query = searchQuery.trim().toLowerCase();
    if (!query) return filteredProducts;
    return filteredProducts.filter((product) =>
      product.name.toLowerCase().includes(query)
    );
  }, [filteredProducts, searchQuery]);

  return (
    <div className="rounded-3xl border border-gray-200 bg-white p-4 shadow-sm">
      <div className="grid gap-4 sm:grid-cols-2 mb-6">
        <SelectField
          id="productCategory"
          label="Category"
          options={categories}
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        />
        <div className="space-y-1">
          <label htmlFor="productSearch" className="block text-sm font-medium text-gray-700">
            Search Products
          </label>
          <input
            id="productSearch"
            name="productSearch"
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Type product name..."
            className="w-full rounded-xl border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium outline-none transition duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
          />
        </div>
      </div>
      <div className="grid gap-2 sm:grid-cols-2 xl:grid-cols-3 h-[200px] 2xl:h-[400px] overflow-auto">
        {displayedProducts.map((product) => {
          const availability = getProductAvailability(
            product,
            (receiptItems.find((item) => item.id === product.id)?.quantity || 0) + 1
          );
          return (
            <ProductCard
              key={product.id}
              product={product}
              onSelect={addReceiptItem}
              disabled={!availability.available}
              statusText={!availability.available ? availability.statusText : ''}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ProductListingSection;
